import './Description.scss';
import { InitiativeMedia } from './Media';
import { InitiativeSection } from './general';
import { JiraSummary } from './jira/JiraSummary';
import { TextEditor } from '@periscopes/general/editor';
import { When } from 'react-if';
import { COPY_SPECIFIC, PLACEHOLDERS_COPY } from '@sonar-software/sonar-ts-constants';
import { coreActions, FeatureFlag } from '@sonar-software/sonar-core';
import React, { useCallback } from 'react';
import { useAction, useFeatureFlag } from '@hooks';
export const InitiativeDescription = ({ description, initiativeId }) => {
    const patchInitiative = useAction(coreActions.requestPatchCoreInitiativesById);
    const jiraEnabled = useFeatureFlag(FeatureFlag.JiraIntegration);
    const handleOnSave = useCallback((updatedDescription) => {
        patchInitiative({
            initiativeId: initiativeId,
            patchInitiativeDescription: {
                description: updatedDescription
            }
        });
    }, [initiativeId, patchInitiative]);
    return (React.createElement(InitiativeSection, { id: 'initiative-description', title: COPY_SPECIFIC.DESCRIPTION },
        React.createElement(TextEditor, { canBeEmpty: true, content: description !== null && description !== void 0 ? description : '', onSave: handleOnSave, placeholder: PLACEHOLDERS_COPY.ADD_DESCRIPTION, saveOnBlur: true }),
        React.createElement(InitiativeMedia, { initiativeId: initiativeId }),
        React.createElement(When, { condition: jiraEnabled },
            React.createElement(JiraSummary, { initiativeId: initiativeId }))));
};
